<template>
  <div
    class="group relative overflow-hidden rounded-[10px] border"
    :style="`background:url(${$getImageSrc(bg)}) no-repeat;background-size:cover;`"
  >
    <div
      class="absolute bottom-0 left-0 right-0 px-[30px] py-[15px] text-[24px] opacity-100 transition-all duration-500 group-hover:bottom-[-20px] group-hover:opacity-0"
      style="background-color: rgba(56, 122, 188, 0.8); color: #fff"
    >
      {{ title }}
    </div>
    <div
      class="p-[35px] pt-[59px] opacity-0 transition-opacity duration-500 group-hover:opacity-100"
      style="background-color: rgba(56, 122, 188, 0.9); color: #fff"
    >
      <h2 class="cursor-pointer text-[30px]" @click="goToTalentPolicy">{{ title }}</h2>
      <span class="mb-[0] mt-[5px] inline-block h-[4px] w-[41px] bg-white"></span>
      <ul>
        <li
          class="border-b border-[#4d9ed6] transition-all hover:pl-[20px]"
          v-for="(item, key) in articleList"
          :key="key"
        >
          <a
            v-if="item.jumpurl"
            :href="item.jumpurl"
            target="_blank"
            class="dot block overflow-hidden text-ellipsis whitespace-nowrap py-[20px] pl-[20px] text-[22px]"
          >
            {{ item.title }}
          </a>
          <router-link
            v-else
            :to="`/detail?channel=policy&id=${item.talent_policy_id}`"
            class="inline-block h-full w-full hover:text-[#f8f9fd]"
          >
            {{ item.title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    title: {
      type: String,
      default: '',
    },
    tid: {
      type: String,
      default: '0',
    },
    articleList: {
      type: Array,
      default: () => [],
    },
    bg: {
      type: String,
      default: 'zc-bg.png',
    },
  },
  methods: {
    goToTalentPolicy() {
      localStorage.setItem('talenPolicyCate', this.tid); // 使用分类回显来高亮
      this.$router.push('/talent-policy');
    },
  },
};
</script>

<style lang="scss" scoped>
.dot {
  position: relative;

  &:before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #fff;
    border-radius: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
